import { useMemo } from 'react';
import { toSnakeCase } from '../../../../utils/toSnakeCase';

export const useWoburnReassignmentReportRows = (rowData) => {
	const {data, headers} = rowData;
  return useMemo(() => {
    return Object.entries(data || {}).reduce((result, [key, value]) => {
      result.push({
        name: key,
        items: value.map((item) => {
             return headers.reduce((acc, header, idx) => {
            acc[toSnakeCase(header)] = item[idx] || "-";
            return acc;
          }, {});
        }),
      });
      return result;
    }, []);
  }, [data, headers]);
};

export default useWoburnReassignmentReportRows;
